module.exports = __webpack_public_path__ + "img/aniket.45c67d2f.jpeg";